import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { authApi } from "@/services/auth/auth-api";
import { useAuthStore } from "@/app/state/auth-store";

/**
 * Hydrates session state once on app load. Runs alongside routing (does not
 * block rendering) so stub/storefront pages remain usable while the session
 * check completes; only auth-aware UI (Header, SignInPage) needs `status`.
 */
export function AuthBootstrap() {
    const setUser = useAuthStore(state => state.setUser);
    const { data, isSuccess, isError } = useQuery({
        queryKey: ["auth", "session"],
        queryFn: authApi.authenticate,
        retry: false
    });

    useEffect(() => {
        if (isSuccess || isError) setUser(isSuccess ? data ?? null : null);
    }, [data, isError, isSuccess, setUser]);

    return null;
}
